export default "__VITE_ASSET__Cz0l$gm1__"